import apiManager from '@/services/API/apiManager'
const SearchVerifiedAgent = async (id) => {
	const verifiedAgent = apiManager.axios
		.post(`v1/admin/agent/search-verifiedAgent`, { startDigits: id })
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return verifiedAgent
}

const SearchPendingAgents = async (id) => {
	const pendingAgent = apiManager.axios
		.post(`v1/admin/agent/search-pendingAgent`, { startDigits: id })
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return pendingAgent
}
const SearchAgentTitle = async (id) => {
	const agentTitle = apiManager.axios
		.post(`v1/admin/incident/searchIncident`, { startDigits: id })
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return agentTitle
}
export default {
	SearchVerifiedAgent,
	SearchPendingAgents,
	SearchAgentTitle,
}
